export const OTP_ERROR_MESSAGE = "OTP is Wrong";
